<div class="container object__container">
  <div class="row">
    @if (boolMultiSelect) {
      <div class="col-md-12 object__col px-0">
        <span class="object__checkbox me-1 mb-2">
          <label class="containerc">
            <input type="checkbox" (change)="selectAllItems()" />
            <span class="checkmark" [ngClass]="{ 'checkmark-gray': !selectAll, 'checkmark-gray-checked': selectAll }"></span>
          </label>
        </span>
      </div>
    }
    @for (obj of itemsArray; track obj; let i = $index) {
      <div id="list{{ obj?.id }}" class="col-md-12 object__col px-0">
        <div class="d-flex justify-content-left align-items-center" [ngClass]="{ object__activeLine: obj?.active }">
          @if (boolMultiSelect) {
            <span class="object__checkbox me-1">
              <label class="containerc containerc--block">
                <input type="checkbox" [(ngModel)]="selected_by_id[i]" (change)="selectItem($event, i)" />
                <span
                  class="checkmark checkmark--block"
                  [ngClass]="{ 'checkmark-gray': !selected_by_id[i], 'checkmark-gray-checked': selected_by_id[i] }"></span>
              </label>
            </span>
          }
          @if (obj) {
            <div
              class="object__body w-100 pt-3"
              (click)="function_two(obj); toggleLine(obj)"
              (keydown)="function_two(obj); toggleLine(obj)"
              [class]="obj.statusColorClass ? obj.statusColorClass : 'object__unread'"
              #objTag>
              <div class="object__header">
                <div class="object__header--left">
                  @if (obj?.icon) {
                    <span [innerHtml]="obj?.icon" class="me-1"></span>
                  }
                  <span class="object__user">{{ obj?.expGroup }}</span>
                </div>
                @if (obj?.statusObjet) {
                  <div
                    class="object__status"
                    [style.color]="obj?.statusObjet?.background"
                    ng-style="{ 'border-right': obj?.statusObjet?.background }"
                    style="border-right: 2px solid; font-size: 12px; line-height: 14px; padding-right: 5px">
                    {{ obj?.statusObjet?.name }}
                  </div>
                }
              </div>
              <div class="object__content mt-1" [ngClass]="{ setMarginMinForSmallScreens: obj?.isTheItemToDisplayMoreMails && isAdvancedSearch }">
                <div class="object__title my-1" pTooltip="{{ obj?.title | maxLength: 300 }}" tooltipPosition="bottom">
                  {{ obj.title | maxLength: 150 }}
                </div>
                <div class="object__bottom mt-1">
                  <div class="object__category">
                    <div class="d-flex align-items-center">
                      @if (obj?.id || obj?.idString) {
                        <span class="me-2 d-flex align-items-center idContainer fs-13px">{{ obj.idString ? obj.idString : obj.id }}</span>
                      }
                      @if (obj?.countLinks) {
                        <div class="object__links d-flex align-items-center me-2" style="font-size: 13px">
                          <i class="bi bi-link-45deg fs_1-25 me-1 object__color"></i>{{ obj?.countLinks }}
                        </div>
                      }
                      @if (obj?.natureId) {
                        <div class="object__links d-flex align-items-center me-2" style="font-size: 13px; margin-bottom: -4px">
                          <i class="bi bi-envelope me-1 object__color"></i>{{ obj?.nature.description }}
                        </div>
                      }
                    </div>
                    <div>
                      @if (obj?.confidentiel === true) {
                        <div class="object__confidential iconPrivate me-2" [pTooltip]="keyLockTooltip">
                          <svg
                            version="1.1"
                            id="Capa_1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                            x="0px"
                            y="0px"
                            viewBox="0 0 512 512"
                            style="enable-background: new 0 0 512 512"
                            xml:space="preserve">
                            <path
                              style="fill: #303c42"
                              d="M437.333,192h-32v-42.667C405.333,66.99,338.344,0,256,0S106.667,66.99,106.667,149.333V192h-32
                                            C68.771,192,64,196.771,64,202.667v266.667C64,492.865,83.135,512,106.667,512h298.667C428.865,512,448,492.865,448,469.333V202.667
                                            C448,196.771,443.229,192,437.333,192z M341.333,192H170.667v-42.667C170.667,102.281,208.948,64,256,64
                                            s85.333,38.281,85.333,85.333V192z" />
                            <path
                              style="fill: #f2f2f2"
                              d="M128,149.333c0-70.583,57.417-128,128-128s128,57.417,128,128V192h-21.333v-42.667
                                            c0-58.813-47.854-106.667-106.667-106.667S149.333,90.521,149.333,149.333V192H128V149.333z" />
                            <path
                              style="fill: #ffca28"
                              d="M426.667,469.333c0,11.76-9.573,21.333-21.333,21.333H106.667c-11.76,0-21.333-9.573-21.333-21.333
                                            v-256h341.333V469.333z" />
                            <path
                              style="opacity: 0.2; fill: #ffffff; enable-background: new"
                              d="M128,469.333v-256H85.333v256
                                            c0,11.76,9.573,21.333,21.333,21.333H144C135.18,490.667,128,481.094,128,469.333z" />
                            <path
                              style="opacity: 0.1; enable-background: new"
                              d="M384,213.333v256c0,11.76-7.18,21.333-16,21.333h37.333
                                            c11.76,0,21.333-9.573,21.333-21.333v-256H384z" />
                            <path
                              style="fill: #303c42"
                              d="M230.792,354.313l-6.729,60.51c-0.333,3.01,0.635,6.031,2.656,8.292
                                            c2.021,2.26,4.917,3.552,7.948,3.552h42.667c3.031,0,5.927-1.292,7.948-3.552c2.021-2.26,2.99-5.281,2.656-8.292l-6.729-60.51
                                            c10.927-7.948,17.458-20.521,17.458-34.313c0-23.531-19.135-42.667-42.667-42.667S213.333,296.469,213.333,320
                                            C213.333,333.792,219.865,346.365,230.792,354.313z" />
                            <path
                              style="fill: #5c6671"
                              d="M256,298.667c11.76,0,21.333,9.573,21.333,21.333c0,8.177-4.646,15.5-12.125,19.125
                                            c-4.073,1.979-6.458,6.292-5.958,10.781l6.167,55.427h-18.833l6.167-55.427c0.5-4.49-1.885-8.802-5.958-10.781
                                            c-7.479-3.625-12.125-10.948-12.125-19.125C234.667,308.24,244.24,298.667,256,298.667z" />
                            <path
                              style="opacity: 0.1; enable-background: new"
                              d="M247.716,340.001c-1.434-2.866-2.383-5.987-2.383-9.335
                                            c0-11.76,9.573-21.333,21.333-21.333c3.12,0,6.034,0.749,8.708,1.958c-3.349-7.406-10.734-12.625-19.375-12.625
                                            c-11.76,0-21.333,9.573-21.333,21.333c0,8.177,4.646,15.5,12.125,19.125C247.193,339.32,247.349,339.763,247.716,340.001z" />
                            <path
                              style="opacity: 0.1; enable-background: new"
                              d="M261.927,373.965l-2.48-22.288c-0.701-0.608-1.125-1.466-1.988-1.885
                                            c-2.096-1.016-3.9-2.376-5.512-3.911c0.385,1.323,0.962,2.599,0.803,4.026l-6.167,55.427h11.853L261.927,373.965z" />
                            <linearGradient
                              id="SVGID_1_"
                              gradientUnits="userSpaceOnUse"
                              x1="-43.622"
                              y1="637.2695"
                              x2="-23.8368"
                              y2="628.0435"
                              gradientTransform="matrix(21.3333 0 0 -21.3333 996.3334 13791.667)">
                              <stop offset="0" style="stop-color: #ffffff; stop-opacity: 0.2" />
                              <stop offset="1" style="stop-color: #ffffff; stop-opacity: 0" />
                            </linearGradient>
                            <path
                              style="fill: url(#SVGID_1_)"
                              d="M437.333,192h-32v-42.667C405.333,66.99,338.344,0,256,0S106.667,66.99,106.667,149.333V192
                                            h-32C68.771,192,64,196.771,64,202.667v266.667C64,492.865,83.135,512,106.667,512h298.667C428.865,512,448,492.865,448,469.333
                                            V202.667C448,196.771,443.229,192,437.333,192z M341.333,192H170.667v-42.667C170.667,102.281,208.948,64,256,64
                                            s85.333,38.281,85.333,85.333V192z" />
                          </svg>
                        </div>
                      }
                    </div>
                  </div>
                  <div>
                    <span class="object__date">
                      {{ obj.date }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    }
    <!-- END DIV OBJECT__HEADER-->
  </div>
</div>
